module.exports = __webpack_public_path__ + "img/mind_background_4.9fbb1003.png";